import React from "react";

export default function Body({ children }) {
  return <div className="flex flex-col">{children}</div>;
}
